import { c as _c } from "react/compiler-runtime";
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { createDataApi } from '../api/dataApi';
import { createDefinitionApi } from '../api/definitionApi';
import { createExportApi } from '../api/exportApi';
import { createPresetApi } from '../api/presetApi';
import { createShareApi } from '../api/shareApi';
import { createSuggestionApi } from '../api/suggestionApi';
import type { ApiContext } from '../api/types';
import { useDataGridErrorContext } from '../context/useDataGridErrorContext';
import { useEagGridStore } from '../store/useEagGridStore';

// TODO: integration test coverage — useHttpCalls is a thin axios wrapper with 26 methods split
// across domain API factories. Each method is trivially testable via integration tests (MSW).
// Low unit-test value-to-effort ratio.
// See https://carvago.atlassian.net/browse/T20-112912 for tracking.

export type UseHttpCalls = {
  gridCode?: string;
  presetInstanceId?: string;
  onApiError?: (error: FetchBaseQueryError) => void;
};
export const useHttpCalls = settings => {
  const $ = _c(20);
  const store = useEagGridStore();
  const errorContext = useDataGridErrorContext();
  let t0;
  if ($[0] !== errorContext || $[1] !== settings) {
    t0 = error => {
      const hasResponse = typeof error === "object" && error !== null && "response" in error;
      const response = hasResponse ? (error as {
        response: FetchBaseQueryError;
      }).response : undefined;
      if (response) {
        settings?.onApiError?.(response);
        errorContext?.onApiError(response);
      }
    };
    $[0] = errorContext;
    $[1] = settings;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleApiError = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[3] !== handleApiError || $[4] !== settings?.gridCode || $[5] !== settings?.presetInstanceId || $[6] !== store) {
    const storeState = store.getState();
    const gridCode = settings?.gridCode ?? storeState.gridCode;
    const presetInstanceId = settings?.presetInstanceId ?? storeState.presetInstanceId;
    const ctx = {
      gridCode,
      presetInstanceId,
      handleApiError
    };
    t1 = createPresetApi(ctx);
    t2 = createDefinitionApi(ctx);
    t3 = createDataApi(ctx);
    t4 = createSuggestionApi(ctx);
    t5 = createExportApi(ctx);
    t6 = createShareApi(ctx);
    $[3] = handleApiError;
    $[4] = settings?.gridCode;
    $[5] = settings?.presetInstanceId;
    $[6] = store;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = {
      ...t1,
      ...t2,
      ...t3,
      ...t4,
      ...t5,
      ...t6
    };
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};